export default __webpack_public_path__ + "static/media/cholet5.514da4a7.jpg";